import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type OnThemeChangedSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type OnThemeChangedSubscription = { __typename?: 'Subscription', themeChanged: string };


export const OnThemeChanged = /*#__PURE__*/ gql`
    subscription OnThemeChanged {
  themeChanged
}
    ` as unknown as DocumentNode<OnThemeChangedSubscription, OnThemeChangedSubscriptionVariables>;

          

          export const useOnThemeChangedSubscription = (options?:SubscriptionHookOptions<OnThemeChangedSubscription, OnThemeChangedSubscriptionVariables>) => useSubscription(OnThemeChanged, options);

          

          export type OnThemeChangedSubscriptionOptions = SubscriptionHookOptions<OnThemeChangedSubscription, OnThemeChangedSubscriptionVariables>;

          

          export type OnThemeChangedSubscriptionResult = ReturnType<typeof useOnThemeChangedSubscription>;

          
